import React, { useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";

const getInitials = (name) =>
  name
    ?.split(" ")
    .slice(0, 2)
    .map((n) => n[0])
    .join("");

// Lists every client chat (one per event) so the admin can start a conversation
const NewMessageModal = ({ show, handleClose, chats, onSelect }) => {
  const [search, setSearch] = useState("");

  useEffect(() => {
    if (!show) setSearch("");
  }, [show]);

  const filteredChats = useMemo(() => {
    const sorted = [...(chats || [])].sort((a, b) =>
      (a?.client?.fullName || "").localeCompare(b?.client?.fullName || "")
    );
    const term = search.trim().toLowerCase();
    if (!term) return sorted;
    return sorted.filter((chat) =>
      chat?.client?.fullName?.toLowerCase().includes(term)
    );
  }, [chats, search]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="border-none justify-content-center">
        <Modal.Title className="mt-3">New Message</Modal.Title>
      </Modal.Header>
      <Modal.Body className="pt-0">
        <div className="messages-search mb-3">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
              stroke="#9F9EA1"
              strokeWidth="1.33333"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
            <path
              d="M13.9996 14.0001L11.0996 11.1001"
              stroke="#9F9EA1"
              strokeWidth="1.33333"
              strokeLinecap="square"
              strokeLinejoin="round"
            />
          </svg>
          <input
            type="text"
            placeholder="Search clients by name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            autoFocus
          />
          {search && (
            <span className="clear-icon" onClick={() => setSearch("")}>
              &times;
            </span>
          )}
        </div>

        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
          {filteredChats.length > 0 ? (
            filteredChats.map((chat) => (
              <div
                key={chat._id}
                onClick={() => onSelect(chat)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  padding: "10px 8px",
                  borderBottom: "1px solid #f0f0f0",
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f6f7")}
                onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
              >
                <span className="avatar2" style={{ flexShrink: 0 }}>
                  {getInitials(chat?.client?.fullName)}
                </span>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontWeight: 500, color: "#132027" }}>
                    {chat?.client?.fullName || "Unknown Client"}
                  </div>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#6e6b78",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {chat?.eventName}
                    {chat?.musician?.fullName && ` · ${chat.musician.fullName}`}
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-data">
              <p>No clients found</p>
            </div>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className="border-none justify-content-center">
        <button className="secondary" type="button" onClick={handleClose}>
          Close
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default NewMessageModal;
